import type { DeploymentProcessPageProps } from "./DeploymentProcessPage";
import { DeploymentProcessPage, deploymentProcessLoader } from "./DeploymentProcessPage";
export type BranchDeploymentProcessPageProps = DeploymentProcessPageProps;
export const branchDeploymentProcessLoader = deploymentProcessLoader;
export function BranchDeploymentProcessPage(props: BranchDeploymentProcessPageProps) {
    return <DeploymentProcessPage {...props}/>;
}
